<template>
  <div>
    <ParentBar />
    <PermissionValidation
      :marketId="marketId"
      rule="enableViewAccounting"
    >
      <router-view></router-view>
    </PermissionValidation>
  </div>
</template>

<script>
import PermissionValidation from "../../components/PermissionValidation.component.vue";
import ParentBar from "../../components/ParentBar.vue";
export default {
  components: {
    PermissionValidation,
    ParentBar,
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
    }
  }
}
</script>

<style>

</style>